import { Component, OnInit } from '@angular/core'
import { LoadingService } from '../../services/loadingService/loading.service'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { NgIf } from '@angular/common'

@Component({
    selector: 'app-loading-global',
    templateUrl: './loading-global.component.html',
    styleUrls: ['./loading-global.component.css'],
    standalone: true,
    imports: [NgIf, MatProgressSpinner],
})
export class LoadingGlobalComponent implements OnInit {
    isLoading = false
    message = ''

    constructor(private loadingService: LoadingService) {}

    ngOnInit(): void {
        this.loadingService.isLoading$.subscribe(
            (isLoading) => (this.isLoading = isLoading)
        )
        this.loadingService.loadingMessage$.subscribe(
            (message) => (this.message = message)
        )
    }
}
